module.exports = __webpack_public_path__ + "img/calapan-medical1.daea24ff.jpg";